import "./NavMenu.scss";
import logo from "../../assets/images/logo.svg";
import { navMenuItems } from "constants/navMenu";
import { useTranslation } from "react-i18next";
import { scrollToSection } from "utils/scroll";
import { useAppDispatch, useAppSelector } from "store";
import { exchangeActions } from "../../store/reducers/exchange";
import { useCallback } from "react";
import Button from "components/Button/Button";
import LocaleDropdown from "components/LocaleDropdown/LocaleDropdown";

const NavMenu = ({
  callback = () => {},
  isCabinet=false,
  logout,
  isSetup=false,
}: {
  callback?: () => void;
  isCabinet?: boolean;
  logout?: () => void;
  isSetup?: boolean;
}) => {
  /*needed to close humburger menu for mobile action*/
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const profileInfo = useAppSelector((state) => state.cabinet);
  const firstLetter = profileInfo?.lastName
    ? profileInfo.lastName.charAt(0).toUpperCase()
    : "";

  const backToStartPage = useCallback(() => {
    window.location.href = "https://www.paypilot.org/";
    isCabinet && logout && logout();
  }, [dispatch, isCabinet, logout]);

  const openSignIn = useCallback(() => {
    dispatch(exchangeActions.setComponentsName("SignIn"));
  }, [dispatch]);
  return (
    <div className="menu-items">
      <img src={logo} alt="logo" onClick={() => backToStartPage()} />
      {isCabinet && <div className="header-avatar">{firstLetter}</div>}
      {(!isCabinet && !isSetup) && (
        <div className="menu-actions">
          <nav>
            <ul className="menu">
              {navMenuItems.map((item, index) => (
                <li key={index} onClick={callback}>
                  <div
                    onClick={() => {
                      if (item.url === "home") {
                        backToStartPage();
                        scrollToSection(item.url);
                      }
                      scrollToSection(item.url);
                    }}
                    className="menu-item"
                  >
                    {t(`menuItems.${item.title}`)}
                  </div>
                </li>
              ))}
            </ul>
          </nav>
          <LocaleDropdown />

          <Button
            btnName="Sign in"
            className="sign-in-btn"
            onClick={() => openSignIn()}
          />
        </div>
      )}
    </div>
  );
};
export default NavMenu;
